module.exports = __webpack_public_path__ + "static/media/paper31.816afc5d.jpg";